import { Box, Text } from '@ltvco/refresh-lib/theme';
import { GavelRounded } from '@mui/icons-material';

import { HeroTitleRow } from './components';

export function LegalIntelligenceHeroSection() {
  return (
    <Box
      component="section"
      aria-labelledby="legal-intelligence-hero-heading"
      sx={{ mb: { xs: 4, sm: 4 } }}
    >
      <HeroTitleRow>
        <Box
          aria-hidden
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            color: theme.palette.primary.main,
            lineHeight: 0,
          })}
        >
          <GavelRounded sx={{ fontSize: 40, display: 'block' }} />
        </Box>
        <Text
          id="legal-intelligence-hero-heading"
          component="h1"
          variant="h1"
          sx={{
            marginBottom: 0,
            marginLeft: 2,
          }}
        >
          Legal Intelligence
        </Text>
      </HeroTitleRow>
      <Text variant="body1" color="text.secondary" sx={{ maxWidth: 720 }}>
        Your centralized platform for comprehensive legal research and document
        discovery. Access court records, regulatory filings, intellectual
        property data, and more.
      </Text>
    </Box>
  );
}
